export type AudienceValue = "allAges" | "sixteenAndUnder" | "seventeenPlus";

export type AudienceOption = { label: string, value: AudienceValue };

export const audienceOptions: AudienceOption[] = [
    { label: 'All Ages', value: 'allAges' },
    { label: '16 and under', value: 'sixteenAndUnder' },
    { label: '17+', value: 'seventeenPlus' },
];